import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiGithub, FiTwitter, FiInstagram, FiFacebook, FiMail } from 'react-icons/fi';
import Logo from '../Logo/Logo';
import { CATEGORIES } from '../../utils/constants';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterStatus, setNewsletterStatus] = useState({ type: '', message: '' });

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setNewsletterStatus({ type: 'loading', message: 'Enviando...' });

    try {
      const response = await fetch('http://localhost:5001/api/newsletter/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: newsletterEmail }),
      });

      const data = await response.json();

      if (response.ok) {
        setNewsletterStatus({ type: 'success', message: data.message });
        setNewsletterEmail('');
      } else {
        setNewsletterStatus({ type: 'error', message: data.error });
      }
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      setNewsletterStatus({ 
        type: 'error', 
        message: 'Error al suscribirse. Intenta nuevamente.' 
      });
    }

    // Clear status message after 5 seconds
    setTimeout(() => {
      setNewsletterStatus({ type: '', message: '' });
    }, 5000);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-section footer-brand">
            <Logo size="medium" showText={true} />
            <p className="footer-description">
              Tu ventana al mundo. Explora historias, descubre perspectivas 
              y conéctate con el contenido que importa.
            </p>
            <div className="footer-social">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FiTwitter />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FiInstagram />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FiFacebook />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FiGithub />
              </a>
            </div>
          </div>

          {/* Categories */}
          <div className="footer-section">
            <h3 className="footer-title">Categorías</h3>
            <ul className="footer-links">
              {CATEGORIES.slice(0, 5).map(category => (
                <li key={category.id}>
                  <Link to={`/explore?category=${category.id}`}>{category.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About */}
          <div className="footer-section">
            <h3 className="footer-title">Sobre Nosotros</h3>
            <ul className="footer-links">
              <li><Link to="/about">Acerca de</Link></li>
              <li><Link to="/about#team">Nuestro Equipo</Link></li>
              <li><Link to="/careers">Trabaja con Nosotros</Link></li>
              <li><Link to="/press">Prensa</Link></li>
              <li><Link to="/contact">Contacto</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="footer-section">
            <h3 className="footer-title">Legal</h3>
            <ul className="footer-links">
              <li><Link to="/privacy">Política de Privacidad</Link></li>
              <li><Link to="/terms">Términos de Servicio</Link></li>
              <li><Link to="/cookies">Política de Cookies</Link></li>
              <li><Link to="/guidelines">Normas de la Comunidad</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="footer-section">
            <h3 className="footer-title">Newsletter</h3>
            <p className="footer-newsletter-text">
              Recibe las mejores historias en tu bandeja de entrada.
            </p>
            <form className="footer-newsletter" onSubmit={handleNewsletterSubmit}>
              <input 
                type="email" 
                placeholder="tu@email.com"
                className="newsletter-input"
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
                required
              />
              <button type="submit" className="newsletter-button" disabled={newsletterStatus.type === 'loading'}>
                <FiMail />
              </button>
            </form>
            {newsletterStatus.message && (
              <p className={`newsletter-status newsletter-status-${newsletterStatus.type}`}>
                {newsletterStatus.message}
              </p>
            )}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} GRAPHYRA. Todos los derechos reservados.
          </p>
          <div className="footer-bottom-links">
            <Link to="/sitemap">Mapa del Sitio</Link>
            <span className="separator">•</span>
            <Link to="/accessibility">Accesibilidad</Link>
            <span className="separator">•</span>
            <Link to="/help">Ayuda</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
